import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import PageLoader from 'components/Shared/PageLoader';
import { useAuthReady } from 'hooks/useAuthReady';

const Gateway = ({ component: Component, ...rest }: any) => {
  const { isLoading, hasUser, isProducer } = useAuthReady();

  if (isLoading || !hasUser) {
    return <PageLoader />;
  }

  if (!isProducer) {
    return <Redirect to='/' />;
  }

  return <Route {...rest} render={props => <Component classes={rest.classes} {...props} />} />;
};
export default Gateway;
